export default {"src":"/_next/static/media/ElectricitySource.8706bcad.svg","height":86,"width":48};